import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// index.html ships a default <meta name="description"> for crawlers that do not run JS.
// Helmet adds its own page-specific one, which leaves two descriptions in <head>.
// Keep exactly one: hide the static default while a Helmet-managed one exists, and
// put it back on pages that don't set their own.
const staticDescription = document.head.querySelector('meta[name="description"]');
if (staticDescription && typeof MutationObserver !== 'undefined') {
  const reconcileDescription = () => {
    const hasPageSpecific = document.head.querySelector('meta[name="description"][data-rh]');
    if (hasPageSpecific && staticDescription.isConnected) {
      staticDescription.remove();
    } else if (!hasPageSpecific && !staticDescription.isConnected) {
      document.head.appendChild(staticDescription);
    }
  };
  new MutationObserver(reconcileDescription).observe(document.head, { childList: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
